import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'shorten'
})
export class ShortenPipe implements PipeTransform {
  transform(value: string, limit ?: number, noSuspensive?: boolean) {
    if (!limit) {
      limit = 20;
    }
    if (value.length <= limit) {
      return value
    } else {
      if (noSuspensive) {
        return value.substr(0, limit);
      } else {
        return value.substr(0, limit) + '...';
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/shorten.ts